import React, { useEffect, useState , useRef } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate , useNavigationType  } from "react-router-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";

let User = () => {
  let [data, setData] = useState();
 
  let navigate = useNavigate();

  let [count, setCount] = useState();
  let [indexs, setIndex] = useState(0);
  let [indexs1, setIndex1] = useState(0);
  let [sel, setSel] = useState("All");

  let [value, inputvalue] = useState();
  const navigationType = useNavigationType();

  const didRunRef = useRef(false);

  useEffect(() => {
    const ranBefore = sessionStorage.getItem("started"); 
    if (ranBefore === "true") {
     let fibd =  sessionStorage.getItem("userind");
     setIndex(Number(fibd));
     setIndex1(Number(fibd));
     Userss(Number(fibd))
    }else{ 
      Start();
      Userss(indexs);
      sessionStorage.setItem("started", "true");
    }
  }, []);
  

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let Users = async () => {

    try {
      let token = await localStorage.getItem("token");

      let pp = { token, limit: 10, skip: indexs };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/admin/user",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);
          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            setData(Jsson.data);
            setCount(Jsson.count);
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => {});
    } catch (err) {}
  };

  let Userss = async (ss) => {

    try {
      let token = await localStorage.getItem("token");

      let pp = { token, limit: 10, skip: ss };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/admin/user", 
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);
          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            setData(Jsson.data);
            setCount(Jsson.count);
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => {});
    } catch (err) {}
  };


  let ClickCat = (re) => {
    console.log(re, "rrrrrrrrrrrrrr");
    navigate("/category", { state: re });
  };

  function convertAndFormatTimestamp(timestamp, targetTimezone = "en-US") {
    const date = new Date(timestamp);

    const options = {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZoneName: "short",
    };

    return date.toLocaleString(targetTimezone, options);
  }

  let Filter = async () => {

    console.log('this is badddddddddddddddddddddddddddddddddddddddddddddddddddddddddddddd')


    
    if (sel === "All") {
      Users();
    } else {
      setIndex(0);

      try {
        let token = await localStorage.getItem("token");

        let pp = {
          token,
          limit: 10,
          skip: 0,
          search: true,
          active: sel === "Blocked" ? false : true,
        };
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url_bbbs + "/admin/user",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);
            console.log(Jsson, "Jsson");
            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => {});
      } catch (err) {}

      // try {
      //   let token = await localStorage.getItem("token");

      //   let pp = {
      //     token,
      //     limit: 10,
      //     skip: 0,
      //     search: true,
      //     payment_status_msg: sel,
      //   };
      //   let data = await AesEncrypt(pp);

      //   let apicall = await axios({
      //     method: "post",
      //     url: Base_url + "/admin/rent",
      //     data: {
      //       data: data,
      //     },
      //   })
      //     .then((dat) => {
      //       let parsedata = AesDecrypt(dat.data);
      //       let Jsson = JSON.parse(parsedata);

      //       console.log(Jsson, "Jsson");
      //       if (Jsson.status === true) {
      //         setData(Jsson.data);
      //         setCount(Jsson.count);
      //       } else {
      //         alert(Jsson.message);
      //       }
      //     })
      //     .catch((ee) => {
      //       alert(" Failed");
      //     });
      // } catch (err) {
      //   alert(" Failed");
      // }
    }
  };

  // useEffect(() => {
  //   Filter();
  // }, [sel]);

  const handlePageClick = async (event) => {
    console.log(event.selected);
    setIndex(event.selected);
    setIndex1(event.selected);
    sessionStorage.setItem("userind", event.selected );
    // if (sel === "All") {
    //   Users()
    // } else {
    //   let token = await localStorage.getItem("token");

    //   let pp = {
    //     token,
    //     limit: 10,
    //     skip: event.selected,
    //     search: true,
    //     payment_status_msg: sel,
    //   };

    //   try {
    //     let data = await AesEncrypt(pp);

    //     let apicall = await axios({
    //       method: "post",
    //       url: Base_url + "/admin/rent",
    //       data: {
    //         data: data,
    //       },
    //     })
    //       .then((dat) => {
    //         let parsedata = AesDecrypt(dat.data);
    //         let Jsson = JSON.parse(parsedata);

    //         console.log(Jsson, "Jsson");
    //         if (Jsson.status === true) {
    //           setData(Jsson.data);
    //           setCount(Jsson.count);
    //         } else {
    //           alert(Jsson.message);
    //         }
    //       })
    //       .catch((ee) => {
    //         alert(" Failed");
    //       });
    //   } catch (err) {
    //     alert(" Failed");
    //   }
    // }

    if (sel === "All") {
      try {
        let token = await localStorage.getItem("token");

        let pp = { token, limit: 10, skip: event.selected };
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url_bbbs + "/admin/user",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);
            console.log(Jsson, "Jsson");
            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => {});
      } catch (err) {}
    } else {
      try {
        let token = await localStorage.getItem("token");

        let pp = {
          token,
          limit: 10,
          skip: event.selected,
          search: true,
          active: sel === "Blocked" ? false : true,
        };
        let data = await AesEncrypt(pp);

        let apicall = await axios({
          method: "post",
          url: Base_url_bbbs + "/admin/user",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);
            console.log(Jsson, "Jsson");
            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => {});
      } catch (err) {}
    }
  };

  let searchss = async () => {

    if(value === "" || value === undefined || value === null || value === "null"){
      Users()
    }else{
      try {
        let token = await localStorage.getItem("token");
  
        let pp = { token, limit: 10, skip: 0 , value  };
        let data = await AesEncrypt(pp);
  
        let apicall = await axios({
          method: "post",
          url: Base_url_bbbs + "/admin/usersearch",
          data: {
            data: data,
          },
        })
          .then((dat) => {
            let parsedata = AesDecrypt(dat.data);
            let Jsson = JSON.parse(parsedata);
            console.log(Jsson, "Jsson");
            if (Jsson.status === true) {
              setData(Jsson.data);
              setCount(Jsson.count);
            } else {
              alert(Jsson.message);
            }
          })
          .catch((ee) => {});
      } catch (err) {}
    } 
  };

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10" style={{ overflowY : 'scroll' , height : '100vh' , scrollbarWidth : 'none' }}>
          <div className="row" style={{ position : 'sticky' , top : 0 , backgroundColor : '#fff' , }}>
            <div className="col-1">
              {/* <select
                onChange={(e) => {
                  setSel(e.target.value);
                }}
                name="cars"
                id="cars"
              >
                <option value="All" selected={sel === "All" ? true : false}>
                  All
                </option>
                <option
                  value="Blocked"
                  selected={sel === "Blocked" ? true : false}
                >
                  Blocked
                </option>
                <option
                  value="Active"
                  selected={sel === "Active" ? true : false}
                >
                  Active
                </option>
              </select> */}
            </div>
          
            <div className="col-7">
            <ReactPaginate
             forcePage={indexs1}
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={count / 10}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              containerClassName="pagination justify-content-center"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
              breakClassName="page-item"
              breakLinkClassName="page-link"
            />
            </div>

            <div className="col-3">
              <input
                onChange={(e) => {
                  inputvalue(e.target.value);
                }}
                type="text"
                style={{ width: "100%" }}
                placeholder="Enter Name or email or Phoneno"
              />
            </div>
            <div className="col-1">
              <button
                onClick={() => {
                  searchss();
                }}
              >
                Submit
              </button>
            </div>
          </div>
          <div className="row">
            <table class="table">
              <thead class="thead-dark" style={{ position : 'sticky' , top : 50 , backgroundColor : '#fff' , }}>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Name</th>
                  <th scope="col">Phone No</th>
                  <th scope="col">Date</th>
                  <th scope="col">Email</th>
                  <th scope="col"></th>
                  <th scope="col">Active</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((tt, index) => {
                  return (
                    <tr >
                      <th scope="row">
                      {index + indexs * 10 + 1} 
                      </th>
                      <td  onClick={() => {

                        navigate("/useralldetail", { state: tt });
                      }}  style={{ cursor: "pointer" }}>{tt?.name}</td>
                      <td  >
                        
                        <div style={{ display : 'flex' }}>
                        {tt?.phoneno} {
                          tt?.fraud === true ?
                          <div style={{ width : 15 , height : 15 , backgroundColor : tt?.fraud === true ? 'red' : "#999999" ,  borderRadius :  15 ,
                          marginLeft : 10 , marginTop : 3
                        }} > </div>
                        : ""
                        }

                        </div>
                        
                        
                        </td>
                      <td>{convertAndFormatTimestamp(tt?.createdAt)}</td>
                      <td>{tt?.email}</td>
                      <td>
                        <div style={{ display : 'flex' , flexDirection : 'row' ,   justifyContent: 'center',  alignItems: 'center'  }} >
                          <div style={{ width : 10 , height : 10 , backgroundColor : tt?.panshow === false ? 'green' : "#999999" ,  borderRadius :  15 }} >
                            
                          </div>
                          <div style={{ width : 10 , height : 10 , backgroundColor : tt?.aadharshow === false ?  'green' : "#999999" ,  borderRadius :  15 , marginLeft :  10 }} >
                            
                          </div>
                        </div>
                      </td>
                      <td
                        style={{ color: tt?.active === true ? "green" : "red" }}
                      >
                        {tt?.active === true ? "active" : "Blocked"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
     
          </div>
        </div>
      </div>
    </div>
  );
};

export default User;
